.wrapper {
  flex-direction: column;
}

.panel-title {
  margin-bottom: calc(4 * var(--spacer));
}

.panel-title,
.section-title {
  color: var(--chart-300-icon-buttons);
  min-height: calc(4 * var(--spacer));
  line-height: 1.5;
  padding: var(--spacer) calc(2 * var(--spacer));
}

.section-title {
  margin-top: var(--spacer);
  white-space: pre;
}

.smart-list {
  margin-top: var(--spacer);
  margin-bottom: var(--spacer);
  position: relative;

  gz-list-item {
    padding-left: calc(2 * var(--spacer));
    font-size: var(--body-size-large);
  }

  &:not(:first-of-type) {
    &:before {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      height: 1px;
      width: calc(100% - calc(5 * var(--spacer)));
      left: calc(3 * var(--spacer));
      background-color: var(--chart-101-pressed-dividers);
    }
  }
}

.panel-content {
  flex: 2;
}
